import React from "react";
import { CheckCircle } from "@material-ui/icons";
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";

export function CheckedRadioGroup(props) {
  const {
    options = [], defaultValue = "", onChangeHandler, name,
  } = props;
  return (
    <FormControl>
      <RadioGroup
        row
        aria-labelledby="demo-radio-buttons-group-label"
        value={defaultValue}
        name="radio-buttons-group"
        onChange={onChangeHandler}
      >
        {options.map((option) => (
          <FormControlLabel
            key={option.value}
            value={option.value}
            name={name}
            sx={{
              "&.MuiFormControlLabel-root": {
                marginBottom: "0px",
              },
            }}
            control={(
              <Radio
                sx={{
                  "&.Mui-checked": {
                    color: "#f47c21",
                  },
                  "&.MuiRadio-root": {
                    padding: "0 9px",
                  },
                }}
                checkedIcon={<CheckCircle />}
              />
            )}
            label={option.label}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
}
